/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantList } from '../../models/merchant-list';

export interface ApiEnrolmentEnrolmentIdMerchantGet$Params {
  enrolment_id: number;
}

export function apiEnrolmentEnrolmentIdMerchantGet(http: HttpClient, rootUrl: string, params: ApiEnrolmentEnrolmentIdMerchantGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantList>> {
  const rb = new RequestBuilder(rootUrl, apiEnrolmentEnrolmentIdMerchantGet.PATH, 'get');
  if (params) {
    rb.path('enrolment_id', params.enrolment_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantList>;
    })
  );
}

apiEnrolmentEnrolmentIdMerchantGet.PATH = '/api/enrolment/{enrolment_id}/merchant';
